import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */

import { ENTER_DELAY, LEAVE_DELAY, HYSTERSIS_DELAY } from '../../../../internal';
import { useControlled } from '../../../../../internal/hooks';
/**
 * Это общее состояние для тултипов нужно для того чтобы не дожидаться задержки на открытие тултипа,
 * если один из тултипов уже был открыт совсем недавно
 *
 * https://github.com/mui-org/material-ui/pull/18458
 */
var hystersisOpen = false;
var hystersisTimer;
export function useTooltipControllerOpen(dependencies) {
  var childrenRef = dependencies.childrenRef,
    state = dependencies.state,
    props = dependencies.props;
  var timers = state.timers;
  var children = props.children,
    onOpen = props.onOpen,
    onClose = props.onClose;
  var _useControlled = useControlled({
      controlled: props.open,
      default: false
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    open = _useControlled2[0],
    setOpen = _useControlled2[1];
  var handleOpen = function handleOpen() {
    if (open) {
      return;
    }
    window.clearTimeout(hystersisTimer);
    hystersisOpen = true;
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  };
  var handleClose = function handleClose() {
    window.clearTimeout(timers.enter);
    window.clearTimeout(hystersisTimer);
    hystersisTimer = window.setTimeout(function () {
      hystersisOpen = false;
    }, HYSTERSIS_DELAY + LEAVE_DELAY);
    setOpen(false);
    if (onClose) {
      onClose();
    }
    state.ignoreNonTouchEvents = false;
  };
  var createHandleEnter = function createHandleEnter(forward) {
    return function (event) {
      var childrenProps = children.props;
      if (event.type === 'mouseenter' && childrenProps.onMouseEnter && forward) {
        childrenProps.onMouseEnter(event);
      }
      if (state.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      }

      // Удаление title чтобы он не пересекался с тултипом
      // Дожидаться ререндера не нужно
      if (childrenRef.current) {
        childrenRef.current.removeAttribute('title');
      }
      clearTimeout(timers.enter);
      clearTimeout(timers.leave);
      if (ENTER_DELAY && !hystersisOpen) {
        timers.enter = window.setTimeout(function () {
          handleOpen();
        }, ENTER_DELAY);
      } else {
        handleOpen();
      }
    };
  };
  var handleLeave = function handleLeave(event) {
    var childrenProps = children.props;
    if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childrenRef.current) {
      childrenProps.onMouseLeave(event);
    }
    clearTimeout(timers.enter);
    clearTimeout(timers.leave);
    timers.leave = window.setTimeout(function () {
      handleClose();
    }, LEAVE_DELAY);
  };
  return {
    open: open,
    handleOpen: handleOpen,
    handleClose: handleClose,
    createHandleEnter: createHandleEnter,
    handleLeave: handleLeave
  };
}